// extracted by mini-css-extract-plugin
export default {"outer":"classes_outer__8QOXp","container":"classes_container__YOYL+","wrapper":"classes_wrapper__McmIG","box":"classes_box__m4awl","buttonNext":"classes_buttonNext__+VxHk"};